import React, { useState, useEffect, useRef, setState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from "react-router-dom";


import ReactDatePicker from "react-datepicker";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ReactFlagsSelect from "react-flags-select";
import { useAuth } from "../../hooks/AuthProvider";
import { getHeaders } from '../../utils/apis';
import { DoModal, ModalContent } from "../../utils/Modal";

import './AddModUser.css';
import AvatarSelect from '../../components/avatarSelect';

export default function AddModUser(props) {
    const { register, handleSubmit, control, watch, setValue, formState: { errors }, reset } = useForm();

    const [countrySel, setCountrySel] = useState("");

    const [userData, setUserData] = useState(props.userData);
    const [updateUser, setUpdateUser] = useState(false);

    const [tailorShops, setTailorShops] = useState([]);
    const [tailorshop, setTailorShop] = useState({ tailorshop_id: "1", short_name: "YB" });
    const [selectedValue, setSelectedValue] = useState("1");

    const [userConfigLst, setUserConfigLst] = useState([]);

    const [avatarData, setAvatarData] = useState(
        "data:image/jpeg;base64,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");

    const navigate = useNavigate();

    const auth = useAuth();
    if (!auth.user) {
        auth.logOut();

    }

    const [isOpen, setIsopen] = useState(false);
    const showModal = () => setIsopen((prev) => !prev);



    const handleTailorShopSelect = (event) => {

        let ts = tailorShops.find((element) => element.tailorshop_id === event.target.value);
        if (ts) {
            console.log('TS:', ts);
            setTailorShop(ts);
            setSelectedValue(ts.tailorshop_id);
        }
    }


    const setAvatar = (avatar) => {

        console.log('avatar:', avatar['img']);
        if (avatar['img']) {
            fetch(avatar['img'])
                .then(response => response.blob())
                .then(blob => {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    return new Promise((res) => {
                        reader.onloadend = () => {
                            res(reader.result);
                        }
                    })
                }).then(data => {
                    //  console.log("IMG=", data);

                    setAvatarData(data);

                })
        }

    }


    const onSubmit = (data) => {

        if (!auth.user) {
            auth.logOut();
            return;
        }

        // data.preventDefault();
        data['country'] = countrySel;
        data['tailorshop_id'] = tailorshop.tailorshop_id;
        data['avatar'] = avatarData;

        console.debug("DEBUG:", data);

        if (!updateUser) {

            if (data['password1'] === "") {
                alert("Please enter user password");
                return;
            }

            if (data['password1'] !== data['password2']) {
                alert("Passwords do not match. Please re-enter password");
                return;
            }



            fetch("/api/checkexists", {
                method: "POST",
                headers: getHeaders(auth),
                body: JSON.stringify({
                    name: data['usr_name'],
                    type: "users"
                }),
            }).then((response) => response.json())
                .then((rowData) => {
                    if (rowData["result"]) {
                        auth.logOut();
                    }
                    console.log('Check', rowData);
                    if (rowData.length >= 1) {

                        alert("User " + data['usr_name'] + " already existed");
                        return;
                    }

                    // Add new user
                    fetch("/api/adduser", {
                        method: "POST",
                        headers: getHeaders(auth),
                        body: JSON.stringify(data),
                    })
                        .then((response) => response.json())
                        .then((rowData) => {
                            if (rowData["result"]) {
                                if (rowData["result"] === "timeout") {
                                    auth.logOut();
                                } else if (rowData["result"] === "OK") {
                                    console.log("Add new return:", rowData[0]);

                                    alert("Add user successful");
                                    //props.newclientUpdate(data, true);
                                    reset();
                                    navigate(-1);
                                } else {

                                    alert("Error when query DB");
                                }
                            } else {
                                console.log("Add new return:", rowData[0]);

                                alert("Add user successful");
                                //props.newclientUpdate(data, true);
                                reset();
                            }
                            // console.log(rowData);
                        })
                        .catch((error) => { console.log(error); alert("Error call API"); });
                })
                .catch((error) => { console.log(error); alert("Error call API"); });

        } else {


            // Update user
            fetch("/api/user", {
                method: "PATCH",
                headers: getHeaders(auth),
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((rowData) => {
                    if (rowData["result"]) {
                        if (rowData["result"] === "timeout") {
                            auth.logOut();
                        } else if (rowData["result"] === "OK") {

                            alert("Update user is successful");
                            //props.newclientUpdate(data, true);
                            reset();
                            //navigate(-1);
                            window.location.reload();
                        } else {
                            alert("Error when query DB");
                        }
                    } else {
                        alert("Update user is successful");
                        //props.newclientUpdate(data, true);
                        reset();
                        window.location.reload();
                    }
                    // console.log(rowData);
                })
                .catch((error) => { console.log(error); alert("Error call API"); });
        }


        //console.log(data);
    }

    useEffect(() => {

        if (!auth.user) {
            auth.logOut();
            return;
        }

        //   alert("Here");


        if (props.userData) {
            setUserData(props.userData);
            setUpdateUser(true);

            setValue("usr_id", props.userData['usr_id']);
            setValue("usr_name", props.userData['usr_name']);
            setValue("first_name", props.userData['first_name']);
            setValue("last_name", props.userData['last_name']);
            setValue("full_name", props.userData['full_name']);
            setValue("email", props.userData['email']);
            setValue("telephone", props.userData['telephone']);
            setValue("gender", props.userData['gender']);
            setValue("country", props.userData['country']);
            setValue("created_date", props.userData['created_date']);
            setValue("updated_date", props.userData['updated_date']);
            setValue("notes", props.userData['notes']);
            setValue("state", props.userData['state']);
            setValue("config", props.userData['config']);

            setValue("websites", props.userData['websites']);
            if (props.userData['agent_id']) {
                setValue("agent_id", props.userData['agent_id'] + "");

            } else {
                setValue("agent_id", "0");
            }
            setSelectedValue(props.userData['tailorshop_id']);
            setAvatarData(props.userData['avatar']);
            setCountrySel(props.userData['country']);
        } else {
            setValue("agent_id", "0");
        }



        fetch("/api/tailorshops/", {
            method: "GET",
            headers: getHeaders(auth),
        })
            .then((response) => response.json())
            //.then((jsonData) => addId(jsonData, "client_id"))
            .then((rowData) => {
                if (rowData["result"]) { auth.logOut(); return; }
                //getOrderItems(rowData2);
                //console.log(rowData);
                setTailorShops(rowData);

                if (rowData.length >= 1) {
                    setTailorShop(rowData[0]);
                }

            })
            .catch((error) => console.log(error));

        fetch("/api/usrconfig", {
            method: "GET",
            headers: getHeaders(auth),
        })
            .then((response) => response.json())
            //.then((jsonData) => addId(jsonData, "client_id"))
            .then((rowData) => {
                if (rowData["result"]) { auth.logOut(); return; }
                //getOrderItems(rowData2);
                //console.log(rowData);
                setUserConfigLst(rowData);

                // if (rowData.length >= 1) {
                //     setUserConfigLst([rowData[0]]);
                // }

            })
            .catch((error) => console.log(error));


    }, [props]);

    // useEffect(() => {
    //     if (props.userData) {
    //         setUserData(props.userData);
    //         setUpdateUser(true);

    //         setValue("usr_id", props.userData['usr_id']);
    //         setValue("usr_name", props.userData['usr_name']);
    //         setValue("first_name", props.userData['first_name']);
    //         setValue("last_name", props.userData['last_name']);
    //         setValue("full_name", props.userData['full_name']);
    //         setValue("email", props.userData['email']);
    //         setValue("telephone", props.userData['telephone']);
    //         setValue("gender", props.userData['gender']);
    //         setValue("country", props.userData['country']);
    //         setValue("created_date", props.userData['created_date']);
    //         setValue("updated_date", props.userData['updated_date']);
    //         setValue("notes", props.userData['notes']);
    //         setValue("state", props.userData['state']);
    //     }
    // }, [userData]);


    // useEffect(() => {
    //     //alert("Here2");
    //     setUserData(props.userData);
    //     if (props.userData) {
    //         console.debug(props);

    //         setUserData(props.userData);
    //         setUpdateUser(true);

    //         setValue("usr_id", props.userData['usr_id']);
    //         setValue("usr_name", props.userData['usr_name']);
    //         setValue("first_name", props.userData['first_name']);
    //         setValue("last_name", props.userData['last_name']);
    //         setValue("full_name", props.userData['full_name']);
    //         setValue("email", props.userData['email']);
    //         setValue("telephone", props.userData['telephone']);
    //         setValue("gender", props.userData['gender'] + "");
    //         setValue("country", props.userData['country']);
    //         setValue("created_date", props.userData['created_date']);
    //         setValue("updated_date", props.userData['updated_date']);
    //         setValue("notes", props.userData['notes']);
    //         setValue("state", props.userData['state']);
    //         setValue("websites", props.userData['websites']);
    //         setValue("agent_id", props.userData['agent_id']);

    //         setSelectedValue(props.userData['tailorshop_id']);
    //         setAvatarData(props.userData['avatar']);
    //     }
    // }, [props]);


    return (
        <div className="d-flex justify-content-center">
            <form onSubmit={handleSubmit(onSubmit)}>
                <Container className="p-9 ">

                    <Row style={{ width: "100%" }}>
                        <label className="form-select-label p-1" htmlFor="tailorshop"> Select Tailor Shop:</label>
                        <select className="form-select m-2 " aria-label="Tailor shop" style={{ height: "55px", width: "450px" }} id="tailorshop"
                            onChange={handleTailorShopSelect} value={selectedValue}>
                            {/* <option value="0" id="0" defaultValue>All</option> */}

                            {tailorShops.map((shop, idx) => {
                                return (
                                    <option value={shop.tailorshop_id} key={shop.tailorshop_id}>{shop.tailorshop_id} - {shop.name} ({shop.short_name})</option>
                                );
                            })}
                        </select>
                    </Row>
                    <Row style={{ width: "100%" }}>
                        <Col md="6">
                            <img className="mb-3 avatar" src={`${avatarData}`} alt="Avatar" onClick={showModal} />

                            {isOpen && (
                                <ModalContent onClose={() => setIsopen(false)} style={{ margin: "auto" }}>
                                    <AvatarSelect closeModal={showModal} setAvatar={setAvatar} />
                                </ModalContent>
                            )}
                        </Col>
                        <Col md="6">
                            {!updateUser ? <>
                                <div className="mb-3">
                                    <label htmlFor="password1">Password *:</label>&nbsp;<br />
                                    <input id="password1" type="password" placeholder="Enter password" {...register("password1", { required: true })} />
                                </div>
                            </>
                                : <>
                                    <div className="mb-3">
                                        <label htmlFor="usr_name">User Name :</label>&nbsp;<br />
                                        <input id="usr_name" type="text" placeholder="User name" {...register("usr_name", { required: true })} disabled="true" />

                                    </div>
                                </>}
                        </Col>
                    </Row>
                    <Row style={{ width: "100%" }}>
                        {!updateUser && <>
                            <Col md="6">
                                <div className="mb-3">
                                    <label htmlFor="usr_name">User Name *:</label>&nbsp;<br />
                                    {updateUser
                                        ? <input id="usr_name" type="text" placeholder="User name" {...register("usr_name", { required: true })} readOnly="true" />
                                        : <input id="usr_name" type="text" placeholder="User name" {...register("usr_name", { required: true })} />}

                                </div>

                            </Col>
                            <Col md="6">

                                <div className="mb-3">
                                    <label htmlFor="password2">Re-Enter password *:</label>&nbsp;<br />
                                    <input id="password2" type="password" placeholder="Re-enter password" {...register("password2", { required: true })} />
                                </div>

                            </Col>
                        </>}

                        <hr />
                    </Row>


                    <Row style={{ width: "100%" }}>
                        <Col md="6">

                            <div className="mb-3">
                                <label htmlFor="first_name">First Name *:</label>&nbsp;<br />
                                <input id="first_name" type="text" placeholder="First name" {...register("first_name", { required: true })} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="full_name">Full Name:</label>&nbsp;<br />
                                <input id="full_name" type="text" placeholder="Full name" {...register("full_name", {})} />
                            </div>

                            <div className="mb-3">
                                <label htmlFor="email">Email *:</label>&nbsp;<br />
                                <input id="email" type="email" placeholder="Email" {...register("email", { required: true })} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="notes">Notes:</label>&nbsp;<br />

                                <textarea id="notes" name="notes" rows="3" cols="20" {...register("notes", {})}>
                                </textarea>
                            </div>

                        </Col>
                        <Col md="6">
                            <div className="mb-3">
                                <label htmlFor="last_name">Last Name *:</label>&nbsp;<br />
                                <input id="last_name" type="text" placeholder="Last name" {...register("last_name", { required: true })} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="telephone">Telephone:</label>&nbsp;<br />
                                <input id="telephone" type="text" placeholder="Telephone" {...register("telephone", {})} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="gender">Gender:</label>&nbsp;<br />
                                <select id="gender" {...register("gender")} className="form-select" style={{ width: "225px" }}>
                                    <option value="1">female</option>
                                    <option value="0">male</option>
                                    <option value="2">other</option>
                                </select>
                            </div>
                            <label htmlFor="country">Country:</label>&nbsp;<br />
                            <ReactFlagsSelect id="country"
                                className="mb-3 menu-flags"
                                // countries={["VN", "US", "GB", "FR", "DE", "IT"]}
                                selected={countrySel}
                                onSelect={(code) => setCountrySel(code)}
                                fullWidth={false}


                            />

                        </Col>
                        <hr />
                    </Row>
                    <Row style={{ width: "100%" }}>
                        <Col md="6">
                            <div className="mb-3">
                                <label htmlFor="websites">Websites:</label>&nbsp;<br />
                                <input id="websites" type="text" placeholder="Websites" {...register("websites", { required: false })} />
                            </div>
                        </Col>
                        <Col md="6">
                            <div className="mb-3">
                                <label htmlFor="agent_id">Agent Id *:</label>&nbsp;<br />
                                <input id="agent_id" type="text" placeholder="Agent ID" {...register("agent_id", { required: true })} />
                            </div>
                        </Col>
                    </Row>
                    <Row style={{ width: "100%" }}>
                        <Col md="6">
                            <div className="mb-3">
                                <label htmlFor="config">Delta Config:</label>&nbsp;<br />
                                <select id="config" {...register("config")} className="form-select" style={{ width: "225px" }}>
                                    <option value="0">Use Shop's Delta Set</option>

                                    {userConfigLst.map((usrCfg, idx) => {
                                        return (
                                            <option value={usrCfg.config_id} key={usrCfg.config_id}>
                                                {usrCfg.config_name} ({usrCfg.config_id})
                                            </option>
                                        );
                                    })}

                                </select>
                            </div>
                        </Col>
                        <Col md="6">
                            &nbsp;
                        </Col>
                    </Row>
                    {/* DEBUG:{JSON.stringify(userConfigLst)} */}
                </Container>
                {/* <button type="submit" className="btn btn-primary btn-sm">Add/Update user</button> */}
                {updateUser
                    ? <button type="submit" className="btn btn-primary btn-sm">Update</button>
                    : <button type="submit" className="btn btn-primary btn-sm">Add</button>}

            </form>
        </div>
    );
}




